import React from "react"
import {useLocal, useModal, useSolution} from "../AppContext"
import {iconShare} from "../Helper/Icons"
import style from "./PlanningCode.css"
import {Clipboard} from "./Clipboard";
import {ShareIcon, ShareText} from "./ShareIcon";

export const PlanningCode = () => {
    const solution = useSolution()
    const modal = useModal()
    const local = useLocal()

    const actionShare = () => {
        modal.openSolutionLoad()
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('solutionShare', {detail: solution.getCode()}))
        }, 100);
    }

    if (solution.getCode()) {
        return <div className={style.container}>
            <ShareText>
                {solution.getCode()}
            </ShareText>
            <ShareIcon/>
            <Clipboard code={solution.getCode()}/>
        </div>
    }

    return '-'
}
